import { ItemsTable } from "../views/Integrations/ItemsTable";
import { ListRequest } from "../views/Integrations/ListRequests";

import InventoryIcon from '@mui/icons-material/Inventory';

export const integrationsRoutes = [
  {
    collapse: true,
    name: "Integraciones",
    icon: InventoryIcon,
    state: "IntegrateCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "INTEGRATIONS",
    views: [
      {
        path: "/integration_items",
        name: "Artículos",
        mini: "II",
        component: ItemsTable,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "INTEGRATIONS",
      },
      {
        path: "/request-list",
        name: "Solicitudes",
        mini: "LS",
        component: ListRequest,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "INTEGRATIONS",
      },
    ],
  },
]